import { render, staticRenderFns } from "./DeleteComponent.vue?vue&type=template&id=83ed5094"
import script from "./DeleteComponent.vue?vue&type=script&lang=js"
export * from "./DeleteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports